import React from "react";

export const getChildren = (alias, files) => {
	const findItem = (alias, items) => {
		for (let item of items) {
			if (item.alias === alias) {
				return item;
			}
			if (item.isFolder && item.children) {
				const found = findItem(alias, item.children);
				if (found) {
					return found;
				}
			}
		}
		return null;
	};

	const item = findItem(alias, files);
	return item ? item.children || [] : [];
};


export const getParents = (alias, files) => {
	const findItemWithParents = (alias, items, parents = []) => {
		for (let item of items) {
			if (item.isFolder == 0) {
				continue;
			}
			if (item.alias === alias) {
				return parents;
			}
			if (item.children) {
				const found = findItemWithParents(alias, item.children, [...parents, item]);
				if (found) {
					return found;
				}
			}
		}
		return null;
	};

	return findItemWithParents(alias, files);
};

export const  updateFileWithHash = (files, selectedFileHash, newChildren) => {
	return files.map(file => {
		if (file.hash === selectedFileHash) {
			return { ...file, children: newChildren };
		} else if (file.children) {
			return { ...file, children: updateFileWithHash(file.children, selectedFileHash, newChildren) };
		}
		return file;
	});
}

export const handleIcon = (file, params = {}) => {
	if (file.isFolder) {
		return (
			<span className={`folder-icon ${params.className || ''}`}>
				<em className="fa fa-folder"></em>
			</span>
		);
	}

	if (file.tmb) {
		return (
			<div className={`file-img-icon ${params.className || ''}`} style={{ backgroundImage: `url(${file.tmb})` }}></div>
		);
	} 

	if (!file.tmb && file.icon) {
		return (
			<div className={`file-img-icon ${params.className || ''}`} style={{ backgroundImage: `url(${file.icon})` }}></div>
		);
	} 
   
	return (
		<span className="file-icon">
			<em className="la la-file"></em>
		</span>
	);
	
}

export const isImageFile = (file) => {
	const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.svg'];
	return imageExtensions.some(extension => file.extension.toLowerCase() == extension);
};

export const openFileInNewTab = (file, download) => {
	const link = document.createElement('a');
	link.href = file.url;
	link.target = '_blank';
	if(download) {
		link.download = file.name;
	}
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
};



export const formatFileSize = (bytes, decimalPoint) => {
	bytes = Number(bytes);
	if (bytes === 0) {
		return '0 Bytes';
	}
	const k = 1000;
	const dm = decimalPoint || 2;
	const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
	const i = Math.floor(Math.log(bytes) / Math.log(k));
	return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};


export const getContextMenuOptions = ({ perms, hasTarget, isSharedFolder, canPaste, selectedFiles }) => {
	const hasFolder = selectedFiles.some(file => file.isFolder);

	return [
		{
			key: "open",
			icon: "la la-eye",
			label: __('buttons_open'),
			visible: perms.canRead && hasTarget,
		},
		{
			key: "refresh",
			icon: "la la-sync",
			label: __('buttons_update'),
			visible: true,
			dividerAfter: true,
		},
		{
			key: "copy",
			icon: "la la-copy",
			label: __('buttons_copy'),
			visible: perms.canEdit && hasTarget,
		},
		{
			key: "cut",
			icon: "la la-cut",
			label: __('buttons_cut'),
			visible: perms.canEdit && hasTarget && !isSharedFolder,
		},
		{
			key: "paste",
			icon: "la la-paste",
			label: __('buttons_paste'),
			visible: perms.canEdit && (canPaste || hasTarget) && !isSharedFolder,
			disabled: !canPaste,
			dividerAfter: true,
		},
		{
			key: "newFolder",
			icon: "la la-plus",
			label: __('buttons_new_folder'),
			visible: perms.canEdit && !hasTarget && !isSharedFolder,
		},
		{
			key: "rename",
			icon: "la la-edit",
			label: __('buttons_rename'),
			visible: perms.canEdit && hasTarget && !isSharedFolder,
			disabled: selectedFiles.length > 1,
		},
		{
			key: "delete",
			icon: "la la-trash",
			label: __('buttons_delete'),
			visible: perms.canEdit && hasTarget && !isSharedFolder,
			dividerAfter: true,
		},
		{
			key: "share",
			icon: "la la-share-square",
			label: __('buttons_share'),
			visible: perms.canShare && hasTarget && !isSharedFolder,
		},
		{
			key: "copyUrl",
			icon: "la la-link",
			label: __('buttons_copy_link'),
			visible: perms.canRead && hasTarget,
			disabled: hasFolder || selectedFiles.length > 1,
		},
		{
			key: "download",
			icon: "la la-download",
			label: __('buttons_download'),
			visible: perms.canRead && hasTarget,
			disabled: hasFolder || selectedFiles.length > 1,
			dividerAfter: true,
		},
		{
			key: "info",
			icon: "la la-info-circle",
			label: __('buttons_info'),
			visible: hasTarget,
			disabled: selectedFiles.length > 1,
		},
	];
};


export const getListViewColumns = () => [
	{
		format: "imageIcon",
		width: "24px",
		align: "left",
		className: "list-icon"
	},
	{
		name: "name",
		width: "250px",
		header: "Nome",
		align: "left",
	},
	{
		name: "owner",
		width: "150px",
		header: "Proprietário",
		align: "left",
	},
	{
		name: "updated_at",
		width: "90px",
		header: "Última Modificação",
		align: "left",
	},
	{
		format: "size",
		width: "100px",
		header: "Tamanho",
		align: "left",
	},
	{
		format: "actions",
		width: "120px",
		align: "right"
	}
]